import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['input', 'sampleIds', 'taskIds'];

  initialize() {
    window.console.log('SampleResultsForm Controller Initialized!');
  }

  preview() {
    const params = {};

    $(this.inputTargets).each((_i, input) => {
      const $input = $(input);
      const name = /sample_results\[(\w+)\]/.exec($input.prop('name'))[1];
      const value = $input.val();

      params[name] = value;
    });

    $.ajax({
      method: 'GET',
      url: '/sample_results/preview',
      data: {
        sample_results: params,
      },
      dataType: 'script',
    });
  }

  addAllTasks(event) {
    event.preventDefault();
    if (this.taskIdsTarget.tomselect) {
      this.taskIdsTarget.tomselect.setValue(this.taskIds);
    }
  }

  addAllSamples(event) {
    event.preventDefault();
    if (this.sampleIdsTarget.tomselect) {
      this.sampleIdsTarget.tomselect.setValue(this.sampleIds);
    }
  }

  get taskIds() {
    return Array.from(this.taskIdsTarget.options).map(option => option.value);
  }

  get sampleIds() {
    return Array.from(this.sampleIdsTarget.options).map(option => option.value);
  }
}
